import { render, staticRenderFns } from "./DatosPersonales.vue?vue&type=template&id=75f50300"
import script from "./DatosPersonales.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosPersonales.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports